// Services
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class SearchService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getSuggestDataCategoryResults(searchType, q) {
        const urlParams = { searchType };
        const getParams = { q };
        const requestUrl = this.urlsService.getUrl(this.urlsService.SEARCH.SUGGEST, urlParams);
        return this.ajaxService.getDataObserveBody(requestUrl, getParams);
    }
    getSuggestDataListResults(searchType, q) {
        const urlParams = { searchType };
        const getParams = { q };
        const requestUrl = this.urlsService.getUrl(this.urlsService.SEARCH.SUGGEST, urlParams);
        return this.ajaxService.getDataObserveBody(requestUrl, getParams);
    }
    getSearchAllResults(searchType, queryInput, pageNum) {
        const urlParams = { searchType, queryInput, pageNum };
        const requestUrl = this.urlsService.getUrl(this.urlsService.SEARCH.SEARCH_ALL_DATA);
        return this.ajaxService.getDataObserveBody(requestUrl, urlParams);
    }
}
SearchService.ɵfac = function SearchService_Factory(t) { return new (t || SearchService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
SearchService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SearchService, factory: SearchService.ɵfac, providedIn: 'root' });
